import { CollectionName, Decision } from '@livv/models';
import { doc, getDoc } from 'firebase/firestore';
import useTranslation from 'next-translate/useTranslation';
import { useEffect, useState } from 'react';
import { InternalDocumentLink } from '@components/Links';
import { db } from '@config/firebase/client';
import { TrackingEventName } from '@utils/types/amplitude/events';

interface LawLexWithInlineStyle {
    props: { children: string[] };
}

interface LawLexLinkProps {
    children: string[] | LawLexWithInlineStyle[];
    isNote?: boolean;
}

const LawLexLink = ({ children, isNote }: LawLexLinkProps): JSX.Element => {
    const { t } = useTranslation('common');
    const decisionId =
        typeof children[0] === 'string'
            ? children[0]
            : (children[1] as LawLexWithInlineStyle).props.children[0];
    const [label, setLabel] = useState<string>(t('seeDecision'));

    useEffect(() => {
        const getDecisionNumber = async () => {
            try {
                const decision = await getDoc(doc(db, `${CollectionName.DECISIONS}/${decisionId}`));
                const { number } = decision.data() as Decision;

                const cleanNumber = number.filter(Boolean).join(', ');
                if (cleanNumber.length) setLabel(cleanNumber);
            } catch (err) {
                console.error(`There was a problem fetching data for ID ${decisionId}`, err);
            }
        };

        getDecisionNumber();
    }, [decisionId, t]);

    return (
        <InternalDocumentLink
            docId={decisionId}
            hideTooltip={isNote}
            sx={{ textDecoration: 'underline' }}
            trackingEventName={isNote ? TrackingEventName.ADVICE_NOTE_CONTENT_CONSUMED : undefined}
            openInNewTab
        >
            {label}
        </InternalDocumentLink>
    );
};

export default LawLexLink;
